import { render, staticRenderFns } from "./KonvaCampaignCellBigCard.vue?vue&type=template&id=19e8f6f3"
import script from "./KonvaCampaignCellBigCard.vue?vue&type=script&lang=js"
export * from "./KonvaCampaignCellBigCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports